import React, { useCallback, useState } from 'react';
import { ImageBackground, StyleSheet, View, } from 'react-native';
import { withTheme } from '@rneui/themed';
import { FAIcon } from '../elements';
import { Image as SkeletonImage } from '../skeleton';
import { useBunnyOptimizedImageUri, useImageSize } from '../../utils';
export const UnthemedListItemAvatar = ({ source, isLocked = true, containerStyle, lockedBackgroundStyle, lockedStyle, lockStyle, borderRadius, width = 144, }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const optimizedUri = useBunnyOptimizedImageUri(source?.uri, {
        width,
    });
    const { aspectRatio } = useImageSize(optimizedUri);
    const onLoad = useCallback(() => {
        setIsLoaded(true);
    }, []);
    return (React.createElement(ImageBackground, { source: { uri: optimizedUri }, style: [
            containerStyle,
            {
                width: width,
                height: width / (aspectRatio || 1)
            },
        ], onLoadEnd: onLoad },
        React.createElement(View, { style: [
                StyleSheet.absoluteFillObject,
                { display: isLoaded ? "none" : undefined },
            ] },
            React.createElement(SkeletonImage, { width: width + 2, height: (width / (aspectRatio || 1)) + 2, borderRadius: borderRadius })),
        React.createElement(View, { style: [
                isLocked ? lockedStyle : undefined,
                {
                    opacity: lockedBackgroundStyle?.opacity ?? 0.5,
                    backgroundColor: lockedBackgroundStyle?.backgroundColor ?? 'black',
                },
            ] }, isLocked && React.createElement(FAIcon, { name: "lock", style: lockStyle }))));
};
export const ListItemAvatar = withTheme(UnthemedListItemAvatar, 'ListItemAvatar');
//# sourceMappingURL=ListItemAvatar.web.js.map